// axios
import axios from 'axios';
// routes
import {routes} from "../../../features/routes/route";
// config
import {MoghavematConfig} from "../../../config/moghavematConfig";

export const getProvince = async (data: any) => {
    const {data: response} = await axios.get(`${routes.api[2].address}location/provinces`, MoghavematConfig);
    return response;
};
